import { useState, useEffect } from 'react';

// ============================================================================
// LOCALSTORAGE CUSTOM HOOKS
// ============================================================================

export function useLocalStorageState<T>(key: string, defaultValue: T) {
  const [state, setState] = useState<T>(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) {
        return JSON.parse(saved);
      }
    } catch (error) {
      console.warn(`Failed to load ${key} from localStorage:`, error);
    }
    return defaultValue;
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`Failed to save ${key} to localStorage:`, error);
    }
  }, [key, state]);

  return [state, setState] as const;
}

export function useFeatureInfoCollapsed() {
  return useLocalStorageState('featureInfoCollapsed', window.innerHeight <= 1024);
}

export function useExpandedAccordions(defaultValue: Set<string>) {
  const [state, setState] = useState<Set<string>>(() => {
    try {
      const saved = localStorage.getItem('expandedAccordions');
      if (saved !== null) {
        return new Set(JSON.parse(saved));
      }
    } catch (error) {
      console.warn('Failed to load expanded accordions from localStorage:', error);
    }
    return defaultValue;
  });

  useEffect(() => {
    try {
      localStorage.setItem('expandedAccordions', JSON.stringify(Array.from(state)));
    } catch (error) {
      console.warn('Failed to save expanded accordions to localStorage:', error);
    }
  }, [state]);

  return [state, setState] as const;
}

